export default __webpack_public_path__ + "static/media/cal_bg4.555751bb.jpg";